import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const CrossBorderStructuring = () => {
  const serviceData = {
    title: "FEMA & Cross-Border Advisory",
    heading: "FEMA & Cross-Border Advisory",
    image: subTopicImages["FEMA & Cross-Border Advisory"],
    intro:
      "Specialised advisory on foreign investment and cross-border transactions",
    description: [
      "Foreign investment in India is governed by the Foreign Exchange Management Act (FEMA) and monitored by the Reserve Bank of India (RBI). These regulations control funding, ownership structures, pricing norms, profit repatriation and reporting requirements.",
      "Non-compliance may result in penalties, business disruption and regulatory scrutiny.",
      "At V DOOGAR AND ASSOCIATES, we help multinational companies, foreign shareholders and cross-border entities comply with FEMA regulations — ensuring transactions remain fully compliant while supporting commercial objectives.",
    ],
    services: [
      {
        title: "Foreign Direct Investment (FDI) Advisory",
        text: "We advise on:",
        list: [
          "permissible investment routes",
          "sector caps and conditions",
          "ownership and control norms",
          "downstream investment rules",
        ],
        extraInfo:
          "Ensuring FDI is structured correctly and in full compliance with applicable regulations.",
      },
      {
        title: "Funding & Capital Transactions",
        text: "Support includes:",
        list: [
          "capital infusion",
          "equity issuance",
          "convertible instruments",
          "ECBs and debt infusion",
          "rights and bonus issues",
        ],
        extraInfo:
          "With full regulatory alignment under FEMA and RBI guidelines.",
      },
      {
        title: "Profit Repatriation & Cross-Border Flows",
        text: "We guide on:",
        list: [
          "dividend remittance",
          "royalty and fee payments",
          "transfer pricing coordination",
          "withholding tax implications",
          "foreign exchange controls",
        ],
        extraInfo:
          "Ensuring smooth and compliant cross-border movement of funds.",
      },
      {
        title: "FEMA Reporting & RBI Filings",
        text: "We manage filings such as:",
        list: [
          "FC-GPR",
          "FC-TRS",
          "ECB filings",
          "Annual return on foreign liabilities and assets",
          "Compounding applications, where required",
        ],
        extraInfo: "Ensuring timely, accurate and audit-ready submissions.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Full FEMA compliance confidence",
      "Smooth capital & transaction flow",
      "Reduced penalty & litigation exposure",
      "Strong documentation and reporting discipline",
      "Comfort for boards, auditors & regulators",
    ],
    research:
      "Our FEMA specialists work closely with tax, legal and audit teams — delivering holistic, risk-managed cross-border advisory trusted by multinational businesses.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default CrossBorderStructuring;
